// ═══ 기간 필터(today/week/month/custom) → {from, to} ===
// EvalAdminPage 등 날짜 범위 필터 UI에서 사용. 모두 'YYYY-MM-DD' 문자열.
function getDateRange(dateFilter, customFrom, customTo) {
  var today = new Date();
  var yyyy = today.getFullYear();
  var mm = String(today.getMonth() + 1).padStart(2, '0');
  var dd = String(today.getDate()).padStart(2, '0');
  var todayStr = yyyy + '-' + mm + '-' + dd;

  if (dateFilter === 'today') return { from: todayStr, to: todayStr };
  if (dateFilter === 'week') {
    var day = today.getDay();
    var mondayOffset = day === 0 ? -6 : 1 - day;
    var monday = new Date(today);
    monday.setDate(today.getDate() + mondayOffset);
    var sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);
    return {
      from: monday.getFullYear() + '-' + String(monday.getMonth() + 1).padStart(2, '0') + '-' + String(monday.getDate()).padStart(2, '0'),
      to: sunday.getFullYear() + '-' + String(sunday.getMonth() + 1).padStart(2, '0') + '-' + String(sunday.getDate()).padStart(2, '0'),
    };
  }
  if (dateFilter === 'month') return { from: yyyy + '-' + mm + '-01', to: yyyy + '-' + mm + '-31' };
  if (dateFilter === 'custom' && customFrom) return { from: customFrom, to: customTo || '9999-12-31' };
  return null;
}

export { getDateRange };
